import { Controller } from 'stimulus'

export default class SettingsSearchController extends Controller {
  static targets = ['input', 'card', 'section', 'empty']

  connect() { this.filter() }

  filter() {
    const tokens = this.inputTarget.value.toLowerCase().split(/\s+/).filter(Boolean)

    this.cardTargets.forEach((card) => {
      card.hidden = !tokens.every((token) => card.dataset.searchText.includes(token))
    })

    this.sectionTargets.forEach((section) => {
      section.hidden = !section.querySelector('[data-settings-search-target="card"]:not([hidden])')
    })

    this.emptyTarget.hidden = this.cardTargets.some((card) => !card.hidden)
  }
}
